export function asArray(data) {
  if (Array.isArray(data)) return data;
  if (data?.$values && Array.isArray(data.$values)) {
    return data.$values.filter(item => item && !item.$ref);
  }
  return [];
}

export function normalizeGoalMap(raw) {
  if (!raw || typeof raw !== 'object') return {};

  return Object.entries(raw).reduce((acc, [categoryId, value]) => {
    const parsed = Number(value);
    if (!Number.isFinite(parsed) || parsed <= 0) return acc;
    acc[categoryId] = Math.round(parsed * 100) / 100;
    return acc;
  }, {});
}

export function buildGoalProgress(categories, categoryChanges, goalMap) {
  const categoryList = asArray(categories);
  const changeList = asArray(categoryChanges);

  const spentByCategoryId = new Map(
    changeList.map(item => [item.categoryId, Number(item.currentAmount) || 0])
  );

  return categoryList
    .filter(category => goalMap[category.id] !== undefined)
    .map(category => {
      const target = goalMap[category.id];
      const spent = spentByCategoryId.get(category.id) || 0;
      const ratio = target > 0 ? (spent / target) * 100 : 0;

      return {
        categoryId: category.id,
        categoryName: category.name,
        icon: category.icon || '📦',
        target,
        spent,
        ratio,
        remaining: target - spent,
        overTarget: spent > target
      };
    })
    .sort((a, b) => b.ratio - a.ratio);
}
